<form [formGroup]="form" class="formgrid grid">
    <div class="field col-12">
    <label for="accountOwnerInput"
        >Kontoinhaber<ow-validation-mark [control]="form.controls.accountOwner"></ow-validation-mark
    ></label>
    <input type="text" pInputText id="accountOwnerInput" formControlName="accountOwner" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="ibanInput">IBAN<ow-validation-mark [control]="form.controls.iban"></ow-validation-mark></label>
      <input type="text" pInputText id="ibanInput" formControlName="iban" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="bicInput"
        >BIC<ow-validation-mark [control]="form.controls.bic"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="bicInput" formControlName="bic" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="creditInstitutionInput"
        >Kreditinstitut<ow-validation-mark [control]="form.controls.creditInstitution"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="creditInstitutionInput" formControlName="creditInstitution" class="w-full" />
    </div>
    <div class="field col-12">
      <label>SEPA Lastschriftmandat<ow-validation-mark [control]="form.controls.authorize"></ow-validation-mark></label>
      <div class="flex align-items-center gap-2">
        <p-checkbox formControlName="authorize" [binary]="true" inputId="authorizeInput"></p-checkbox>
        <label for="authorizeInput"
          >Ich ermächtige Stadtwerke Saarlouis GmbH, Zahlungen von dem angegebenen Konto mittels Lastschrift einzuziehen. Zugleich
          weise ich das angegebene Kreditinstitut an, die von Stadtwerke Saarlouis GmbH auf das angegebene Konto gezogene Lastschrift
          einzulösen. Die Stadtwerke Saarlouis GmbH akzeptiert ausschließlich das Bankeinzugsverfahren. Eine Barzahlung
          oder Überweisung ist nicht möglich.</label
        >
      </div>
    </div>
  </form>
  